export default __webpack_public_path__ + "static/media/promotions-pic-3.56e23512.jpg";